// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_3MnPy","premiumFolderIcon":"_3MnPy"};